export interface AppConfig {
  keycloakUrl: string;
  keycloakRealm: string;
  keycloakClientId: string;
}

declare global {
  interface Window {
    __APP_CONFIG__?: Partial<AppConfig>;
  }
}

/** Runtime configuration from /config.js (generated by the container entrypoint). */
export function getConfig(): AppConfig {
  const c = window.__APP_CONFIG__ ?? {};
  return {
    keycloakUrl: c.keycloakUrl ?? 'http://localhost:8180',
    keycloakRealm: c.keycloakRealm ?? 'ssi',
    keycloakClientId: c.keycloakClientId ?? 'ssi-frontend',
  };
}
